// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { addAccount as addAccountApi, AddAccountParameter } from "@synd/App/Services/CreateAccount";

type HandlerType = ApiHandlerDiscreteParameter<AddAccountParameter, AddAccountParameter, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const AddAccount: HandlerType = async props => {
    props.apiResult = await addAccountApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, AddAccount, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const addAccount = createHandlerChainRunner(chain, "AddAccount");
export default addAccount;
